import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SUPPORTED_LANGUAGES } from '@/lib/languageConstants';

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const currentLang = SUPPORTED_LANGUAGES.find(l => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="sketch-border hover-sketch bg-paper-sketch relative group"
        >
          <Globe className="h-5 w-5 group-hover:rotate-12 transition-transform" />
          <div className="absolute -bottom-1 -right-1 text-[9px] font-black bg-foreground text-background rounded-full w-5 h-5 flex items-center justify-center sketch-border">
            {currentLang.code.toUpperCase()}
          </div>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="sketch-border bg-paper-sketch">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className="cursor-pointer hover-sketch flex items-center gap-3"
          >
            <span className={`fi fi-${lang.flagCode} text-xl`} title={lang.name} />
            <span className="font-bold">{lang.name}</span>
            {i18n.language === lang.code && (
              <Check className="h-4 w-4 text-primary ml-auto" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
